<template>
    <b-container class="bv-example-row">
        <b-row class="justify-content-md-center">
        <b-col col lg="6">
        <b-card-group deck>
            <b-card border-variant="light" header="Login page" class="text-center">
            <b-card-text>
                <b-form @submit="onSubmit" class="px-2">
            <b-form-group id="exampleInputGroup1"
              label="Superadmin email"
              label-for="exampleInput1">
            
            <b-form-input id="exampleInput1"
                      type="text"
                      v-model="form.username"
                      required
                      autofocus
                      placeholder="Enter superadmin e-mail"/>
            </b-form-group>

            <b-form-group id="exampleInputGroup1"
              label="Password"
              label-for="exampleInput1">
            
              <b-form-input id="exampleInput1"
                        type="password"
                        v-model="form.password"
                        required
                        placeholder="Enter password" />
            </b-form-group>
            
            <p v-if="error_message" class="text-danger font-weight-bold">
              {{error_message}}
            </p>
            
            <p v-if="redirect_to" class="text-danger font-weight-bold">
              After login you will be redirect to "{{ redirect_to }}" endpoint
            </p>
            
            <div>
              <b-button type="submit" variant="primary" class="my-2">Submit</b-button>
            </div>
          </b-form>
            </b-card-text>
        </b-card>
        </b-card-group>
        </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import functions from '../main'

    export default {
        props: ['error_message'],
        data() {
            return {
                form: {
                    username: '',
                    password: '',
                },
                redirect_to : null,
            }
        },
        created(){
          this.redirect_to = this.$store.getters.redirectTo
        },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        functions.login(this.form.username, this.form.password)
          .then(() => this.$router.push({path: this.redirect_to ? this.redirect_to : "/", params: { message: "You logged in as "+this.form.username+"!" } }))
          .catch(error => {
            this.error_message= "Invalid user credentials"
          })       
      },
    },
  }
</script>
